module.exports = __webpack_public_path__ + "img/RelationshipDoDFooterBanner.a63cad71.png";